"use strict";
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.ApiException = exports.MeetingInfo = exports.SummaryInfo = exports.LocationInfo = exports.ParticipantInfo = exports.SpeakerTranscript = exports.SpeakerFileInfo = exports.MeetingTranscript = exports.MeetingTranscriptRow = exports.AddTranscriptRequest = exports.MeetingStatistics = exports.TagCount = exports.MeetingListItem = exports.ParticipantAvatar = exports.Meeting = exports.Summary = exports.SummaryType = exports.Tag = exports.Location = exports.Participant = exports.SummeetClient = void 0;
var SummeetClient = /** @class */ (function () {
    function SummeetClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    SummeetClient.prototype.findMeetingsByRecordingId = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/_findByRecordingId";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processFindMeetingsByRecordingId(_response);
        });
    };
    SummeetClient.prototype.processFindMeetingsByRecordingId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(item);
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    SummeetClient.prototype.add = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAdd(_response);
        });
    };
    SummeetClient.prototype.processAdd = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.list = function () {
        var _this = this;
        var url_ = this.baseUrl + "/meetings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processList(_response);
        });
    };
    SummeetClient.prototype.processList = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(MeetingListItem.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param idType (optional)
     * @param id (optional)
     * @return Success
     */
    SummeetClient.prototype.getByExternalId = function (idType, id) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/_byExternalId?";
        if (idType !== undefined && idType !== null)
            url_ += "idType=" + encodeURIComponent("" + idType) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetByExternalId(_response);
        });
    };
    SummeetClient.prototype.processGetByExternalId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Meeting.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.getById = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{id}/fullInfo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetById(_response);
        });
    };
    SummeetClient.prototype.processGetById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Meeting.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.listFull = function () {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/__listFull";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processListFull(_response);
        });
    };
    SummeetClient.prototype.processListFull = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(Meeting.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.getPopularTags = function () {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/popularTags";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetPopularTags(_response);
        });
    };
    SummeetClient.prototype.processGetPopularTags = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(TagCount.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.getMeetingStatistics = function () {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/statistics";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMeetingStatistics(_response);
        });
    };
    SummeetClient.prototype.processGetMeetingStatistics = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MeetingStatistics.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    SummeetClient.prototype.addTranscript = function (meetingId, body) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{meetingId}/transcript";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAddTranscript(_response);
        });
    };
    SummeetClient.prototype.processAddTranscript = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.getMeetingTranscript = function (meetingId) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{meetingId}/transcript";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMeetingTranscript(_response);
        });
    };
    SummeetClient.prototype.processGetMeetingTranscript = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MeetingTranscript.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param asrName (optional)
     * @return Success
     */
    SummeetClient.prototype.getSpeakersFiles = function (meetingId, asrName) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{meetingId}/speakers?";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (asrName !== undefined && asrName !== null)
            url_ += "asrName=" + encodeURIComponent("" + asrName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetSpeakersFiles(_response);
        });
    };
    SummeetClient.prototype.processGetSpeakersFiles = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(SpeakerFileInfo.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.streamMediaForAsr = function (meetingId, speakerFileName) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{meetingId}/speakers/{speakerFileName}/asr";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (speakerFileName === undefined || speakerFileName === null)
            throw new Error("The parameter 'speakerFileName' must be defined.");
        url_ = url_.replace("{speakerFileName}", encodeURIComponent("" + speakerFileName));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processStreamMediaForAsr(_response);
        });
    };
    SummeetClient.prototype.processStreamMediaForAsr = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_1 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_1, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.getSpeakerTranscripts = function (meetingId) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{meetingId}/speakers/transcripts";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetSpeakerTranscripts(_response);
        });
    };
    SummeetClient.prototype.processGetSpeakerTranscripts = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(SpeakerTranscript.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.streamMediaRaw = function (meetingId, speakerFileName) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{meetingId}/speakers/{speakerFileName}/raw";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (speakerFileName === undefined || speakerFileName === null)
            throw new Error("The parameter 'speakerFileName' must be defined.");
        url_ = url_.replace("{speakerFileName}", encodeURIComponent("" + speakerFileName));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processStreamMediaRaw(_response);
        });
    };
    SummeetClient.prototype.processStreamMediaRaw = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_2 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_2, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.streamAudio = function (meetingId) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{meetingId}/audio";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processStreamAudio(_response);
        });
    };
    SummeetClient.prototype.processStreamAudio = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            var fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            var fileName_3 = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(function (blob) { return { fileName: fileName_3, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @param duration (optional)
     * @return Success
     */
    SummeetClient.prototype.updateDuration = function (meetingId, duration) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{meetingId}/duration?";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (duration === null)
            throw new Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "duration=" + encodeURIComponent("" + duration) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUpdateDuration(_response);
        });
    };
    SummeetClient.prototype.processUpdateDuration = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SummeetClient.prototype.getMeetingInfo = function (meetingId) {
        var _this = this;
        var url_ = this.baseUrl + "/meetings/{meetingId}";
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMeetingInfo(_response);
        });
    };
    SummeetClient.prototype.processGetMeetingInfo = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MeetingInfo.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return SummeetClient;
}());
exports.SummeetClient = SummeetClient;
var Participant = /** @class */ (function () {
    function Participant(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Participant.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.avatar = _data["avatar"];
            this.meta = _data["meta"];
        }
    };
    Participant.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Participant();
        result.init(data);
        return result;
    };
    Participant.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["avatar"] = this.avatar;
        data["meta"] = this.meta;
        return data;
    };
    return Participant;
}());
exports.Participant = Participant;
var Location = /** @class */ (function () {
    function Location(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Location.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.meta = _data["meta"];
        }
    };
    Location.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Location();
        result.init(data);
        return result;
    };
    Location.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["meta"] = this.meta;
        return data;
    };
    return Location;
}());
exports.Location = Location;
var Tag = /** @class */ (function () {
    function Tag(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Tag.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    Tag.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Tag();
        result.init(data);
        return result;
    };
    Tag.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return Tag;
}());
exports.Tag = Tag;
var SummaryType;
(function (SummaryType) {
    SummaryType[SummaryType["_0"] = 0] = "_0";
    SummaryType[SummaryType["_1"] = 1] = "_1";
})(SummaryType = exports.SummaryType || (exports.SummaryType = {}));
var Summary = /** @class */ (function () {
    function Summary(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Summary.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.isGenerated = _data["isGenerated"];
            this.meta = _data["meta"];
            this.summaryBlocks = _data["summaryBlocks"];
        }
    };
    Summary.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Summary();
        result.init(data);
        return result;
    };
    Summary.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["isGenerated"] = this.isGenerated;
        data["meta"] = this.meta;
        data["summaryBlocks"] = this.summaryBlocks;
        return data;
    };
    return Summary;
}());
exports.Summary = Summary;
var Meeting = /** @class */ (function () {
    function Meeting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Meeting.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : undefined;
            this.organizer = _data["organizer"] ? Participant.fromJS(_data["organizer"]) : undefined;
            if (Array.isArray(_data["participants"])) {
                this.participants = [];
                for (var _i = 0, _a = _data["participants"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.participants.push(Participant.fromJS(item));
                }
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [];
                for (var _b = 0, _c = _data["locations"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.locations.push(Location.fromJS(item));
                }
            }
            this.meta = _data["meta"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (var _d = 0, _e = _data["tags"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.tags.push(Tag.fromJS(item));
                }
            }
            this.recordingMeta = _data["recordingMeta"];
            if (Array.isArray(_data["summaries"])) {
                this.summaries = [];
                for (var _f = 0, _g = _data["summaries"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.summaries.push(Summary.fromJS(item));
                }
            }
            this.recordingDuration = _data["recordingDuration"];
        }
    };
    Meeting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Meeting();
        result.init(data);
        return result;
    };
    Meeting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : undefined;
        data["organizer"] = this.organizer ? this.organizer.toJSON() : undefined;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (var _i = 0, _a = this.participants; _i < _a.length; _i++) {
                var item = _a[_i];
                data["participants"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (var _b = 0, _c = this.locations; _b < _c.length; _b++) {
                var item = _c[_b];
                data["locations"].push(item.toJSON());
            }
        }
        data["meta"] = this.meta;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (var _d = 0, _e = this.tags; _d < _e.length; _d++) {
                var item = _e[_d];
                data["tags"].push(item.toJSON());
            }
        }
        data["recordingMeta"] = this.recordingMeta;
        if (Array.isArray(this.summaries)) {
            data["summaries"] = [];
            for (var _f = 0, _g = this.summaries; _f < _g.length; _f++) {
                var item = _g[_f];
                data["summaries"].push(item.toJSON());
            }
        }
        data["recordingDuration"] = this.recordingDuration;
        return data;
    };
    return Meeting;
}());
exports.Meeting = Meeting;
var ParticipantAvatar = /** @class */ (function () {
    function ParticipantAvatar(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ParticipantAvatar.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.avatar = _data["avatar"];
        }
    };
    ParticipantAvatar.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ParticipantAvatar();
        result.init(data);
        return result;
    };
    ParticipantAvatar.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        return data;
    };
    return ParticipantAvatar;
}());
exports.ParticipantAvatar = ParticipantAvatar;
var MeetingListItem = /** @class */ (function () {
    function MeetingListItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MeetingListItem.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : undefined;
            this.otherPeopleCount = _data["otherPeopleCount"];
            this.organizer = _data["organizer"] ? ParticipantAvatar.fromJS(_data["organizer"]) : undefined;
            if (Array.isArray(_data["locations"])) {
                this.locations = [];
                for (var _i = 0, _a = _data["locations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.locations.push(item);
                }
            }
        }
    };
    MeetingListItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MeetingListItem();
        result.init(data);
        return result;
    };
    MeetingListItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : undefined;
        data["otherPeopleCount"] = this.otherPeopleCount;
        data["organizer"] = this.organizer ? this.organizer.toJSON() : undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (var _i = 0, _a = this.locations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["locations"].push(item);
            }
        }
        return data;
    };
    return MeetingListItem;
}());
exports.MeetingListItem = MeetingListItem;
var TagCount = /** @class */ (function () {
    function TagCount(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TagCount.prototype.init = function (_data) {
        if (_data) {
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : undefined;
            this.count = _data["count"];
        }
    };
    TagCount.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TagCount();
        result.init(data);
        return result;
    };
    TagCount.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : undefined;
        data["count"] = this.count;
        return data;
    };
    return TagCount;
}());
exports.TagCount = TagCount;
var MeetingStatistics = /** @class */ (function () {
    function MeetingStatistics(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MeetingStatistics.prototype.init = function (_data) {
        if (_data) {
            this.meetingsDurationInMinutes_Mean = _data["meetingsDurationInMinutes_Mean"];
            this.questionsReviewedCount_Mean = _data["questionsReviewedCount_Mean"];
            this.decisionsMadeCount_Mean = _data["decisionsMadeCount_Mean"];
        }
    };
    MeetingStatistics.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MeetingStatistics();
        result.init(data);
        return result;
    };
    MeetingStatistics.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["meetingsDurationInMinutes_Mean"] = this.meetingsDurationInMinutes_Mean;
        data["questionsReviewedCount_Mean"] = this.questionsReviewedCount_Mean;
        data["decisionsMadeCount_Mean"] = this.decisionsMadeCount_Mean;
        return data;
    };
    return MeetingStatistics;
}());
exports.MeetingStatistics = MeetingStatistics;
var AddTranscriptRequest = /** @class */ (function () {
    function AddTranscriptRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddTranscriptRequest.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.speakerId = _data["speakerId"];
            this.rawText = _data["rawText"];
            this.text = _data["text"];
            this.meta = _data["meta"];
        }
    };
    AddTranscriptRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddTranscriptRequest();
        result.init(data);
        return result;
    };
    AddTranscriptRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["speakerId"] = this.speakerId;
        data["rawText"] = this.rawText;
        data["text"] = this.text;
        data["meta"] = this.meta;
        return data;
    };
    return AddTranscriptRequest;
}());
exports.AddTranscriptRequest = AddTranscriptRequest;
var MeetingTranscriptRow = /** @class */ (function () {
    function MeetingTranscriptRow(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MeetingTranscriptRow.prototype.init = function (_data) {
        if (_data) {
            this.startTicks = _data["startTicks"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.durationTicks = _data["durationTicks"];
        }
    };
    MeetingTranscriptRow.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MeetingTranscriptRow();
        result.init(data);
        return result;
    };
    MeetingTranscriptRow.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["startTicks"] = this.startTicks;
        data["name"] = this.name;
        data["text"] = this.text;
        data["durationTicks"] = this.durationTicks;
        return data;
    };
    return MeetingTranscriptRow;
}());
exports.MeetingTranscriptRow = MeetingTranscriptRow;
var MeetingTranscript = /** @class */ (function () {
    function MeetingTranscript(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MeetingTranscript.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [];
                for (var _i = 0, _a = _data["rows"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.rows.push(MeetingTranscriptRow.fromJS(item));
                }
            }
        }
    };
    MeetingTranscript.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MeetingTranscript();
        result.init(data);
        return result;
    };
    MeetingTranscript.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
                var item = _a[_i];
                data["rows"].push(item.toJSON());
            }
        }
        return data;
    };
    return MeetingTranscript;
}());
exports.MeetingTranscript = MeetingTranscript;
var SpeakerFileInfo = /** @class */ (function () {
    function SpeakerFileInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SpeakerFileInfo.prototype.init = function (_data) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.lastASRDateUtc = _data["lastASRDateUtc"] ? new Date(_data["lastASRDateUtc"].toString()) : undefined;
        }
    };
    SpeakerFileInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SpeakerFileInfo();
        result.init(data);
        return result;
    };
    SpeakerFileInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["lastASRDateUtc"] = this.lastASRDateUtc ? this.lastASRDateUtc.toISOString() : undefined;
        return data;
    };
    return SpeakerFileInfo;
}());
exports.SpeakerFileInfo = SpeakerFileInfo;
var SpeakerTranscript = /** @class */ (function () {
    function SpeakerTranscript(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SpeakerTranscript.prototype.init = function (_data) {
        if (_data) {
            this.speakerId = _data["speakerId"];
            this.speakerName = _data["speakerName"];
            this.text = _data["text"];
        }
    };
    SpeakerTranscript.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SpeakerTranscript();
        result.init(data);
        return result;
    };
    SpeakerTranscript.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["speakerName"] = this.speakerName;
        data["text"] = this.text;
        return data;
    };
    return SpeakerTranscript;
}());
exports.SpeakerTranscript = SpeakerTranscript;
var ParticipantInfo = /** @class */ (function () {
    function ParticipantInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ParticipantInfo.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    };
    ParticipantInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ParticipantInfo();
        result.init(data);
        return result;
    };
    ParticipantInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    };
    return ParticipantInfo;
}());
exports.ParticipantInfo = ParticipantInfo;
var LocationInfo = /** @class */ (function () {
    function LocationInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocationInfo.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    };
    LocationInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocationInfo();
        result.init(data);
        return result;
    };
    LocationInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    };
    return LocationInfo;
}());
exports.LocationInfo = LocationInfo;
var SummaryInfo = /** @class */ (function () {
    function SummaryInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SummaryInfo.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.isGenerated = _data["isGenerated"];
            this.summaryBlocks = _data["summaryBlocks"];
        }
    };
    SummaryInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SummaryInfo();
        result.init(data);
        return result;
    };
    SummaryInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["isGenerated"] = this.isGenerated;
        data["summaryBlocks"] = this.summaryBlocks;
        return data;
    };
    return SummaryInfo;
}());
exports.SummaryInfo = SummaryInfo;
var MeetingInfo = /** @class */ (function () {
    function MeetingInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MeetingInfo.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : undefined;
            this.organizer = _data["organizer"] ? ParticipantInfo.fromJS(_data["organizer"]) : undefined;
            if (Array.isArray(_data["participants"])) {
                this.participants = [];
                for (var _i = 0, _a = _data["participants"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.participants.push(ParticipantInfo.fromJS(item));
                }
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [];
                for (var _b = 0, _c = _data["locations"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.locations.push(LocationInfo.fromJS(item));
                }
            }
            if (Array.isArray(_data["summaries"])) {
                this.summaries = [];
                for (var _d = 0, _e = _data["summaries"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.summaries.push(SummaryInfo.fromJS(item));
                }
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (var _f = 0, _g = _data["tags"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.tags.push(Tag.fromJS(item));
                }
            }
        }
    };
    MeetingInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MeetingInfo();
        result.init(data);
        return result;
    };
    MeetingInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : undefined;
        data["organizer"] = this.organizer ? this.organizer.toJSON() : undefined;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (var _i = 0, _a = this.participants; _i < _a.length; _i++) {
                var item = _a[_i];
                data["participants"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (var _b = 0, _c = this.locations; _b < _c.length; _b++) {
                var item = _c[_b];
                data["locations"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.summaries)) {
            data["summaries"] = [];
            for (var _d = 0, _e = this.summaries; _d < _e.length; _d++) {
                var item = _e[_d];
                data["summaries"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (var _f = 0, _g = this.tags; _f < _g.length; _f++) {
                var item = _g[_f];
                data["tags"].push(item.toJSON());
            }
        }
        return data;
    };
    return MeetingInfo;
}());
exports.MeetingInfo = MeetingInfo;
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
